import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ConstantsUtil } from '@utils';
import { ApiResponseStatusText } from '@enums';

/**
 * get Error popup message helper.
 *
 * @author Mikhail Siutsou
 * @function getPopupErrorMessage
 * @category helpers
 * @param {ApiErrorObject} object error
 * @return {ApiErrorObject} new error.
 */
var getPopupErrorMessage = function getPopupErrorMessage(error) {
  var errorObject = _objectSpread({}, error);

  switch (error.name) {
    case ApiResponseStatusText.invalid_grant:
      errorObject.name = ConstantsUtil.errors.INVALID_GRANT;
      errorObject.message = ConstantsUtil.errors.INVALID_GRANT_MESSAGE;
      return errorObject;

    case ApiResponseStatusText.insufficient_scope:
      errorObject.name = ConstantsUtil.errors.INSUFFICIENT_SCOPE;
      errorObject.message = ConstantsUtil.errors.INSUFFICIENT_SCOPE_MESSAGE;
      return errorObject;

    case ApiResponseStatusText.invalid_request:
      errorObject.name = ConstantsUtil.errors.INVALID_REQUEST;
      errorObject.message = ConstantsUtil.errors.INVALID_REQUEST_MESSAGE;
      return errorObject;

    case ApiResponseStatusText.unauthorized:
    case ApiResponseStatusText.invalid_token:
      errorObject.name = ConstantsUtil.errors.INVALID_TOKEN;
      errorObject.message = ConstantsUtil.errors.INVALID_TOKEN_MESSAGE;
      return errorObject;

    case ApiResponseStatusText.server_error:
      errorObject.name = ConstantsUtil.errors.SERVER_ERROR;
      errorObject.message = ConstantsUtil.errors.SERVER_ERROR_MESSAGE;
      return errorObject;

    default:
      return errorObject;
  }
};

export { getPopupErrorMessage };